import { Col, Row } from "antd";
import { useEffect, useState } from "react";
import "./style.css";
import { executiveMetaDataUrl } from "../../Common/endpoints";
import { getApis } from "../../Common/apis";
import DaysPicker from "../../Common/DaysPicker";
import Overview from "./Overview";
import RunningVehicles from "./RunningVehicles";
import { setPageLoader, setPageLastUpdatedTime } from "../../../reducers/loaderSlice";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";

const Metrics = ({ data, timeFilter, onTimeChange }) => {
  const dispatch = useDispatch();
  const [metaData, setMetaData] = useState({});
  const authToken = localStorage.getItem("authToken");

  const getMetaData = async () => {
    const params = {
      startTime: timeFilter?.[data]?.[0],
      endTime: timeFilter?.[data]?.[1],
    };

    await getApis(executiveMetaDataUrl, params, authToken)
      .then((response) => {
        setMetaData(response?.data);
        dispatch(setPageLoader(null));
        dispatch(setPageLastUpdatedTime(Date.now()));
      })
      .catch((err) => {
        console.log(err);
        dispatch(setPageLoader(null));
        //dispatch(setPageLastUpdatedTime(Date.now()));
        // need not update time as api FAILED
      });
  };

  useEffect(() => {
    if (timeFilter?.[data]?.[0]) {
      getMetaData();
    }

    dispatch(setPageLoader("refresh"));
    if (dayjs(timeFilter?.[data]?.[1]) > dayjs().subtract(1, "hour")) {
      const intervalId = setInterval(() => {
        dispatch(setPageLoader("refresh"));
        getMetaData();
      }, 5 * 60 * 1000);

      return () => clearInterval(intervalId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeFilter?.[data]]);

  return (
    <>
      <Row justify={"center"}>
        <Col span={24}>
          <div className="flex-center">
            <DaysPicker
              callApis={getMetaData}
              timeRange={timeFilter?.[data]}
              onTimeChange={(value) => onTimeChange(data, value)}
              customOptions={["Hour", "Day", "Week", "Month"]}
            />
          </div>
        </Col>
      </Row>

      <Overview metaData={metaData} />

      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={24} lg={24} xl={12}>
          <RunningVehicles
            title={"Top"}
            totalKm={metaData?.maxRunning}
            vehicleList={metaData?.topRunningVehicles}
          />
        </Col>
        <Col xs={24} sm={12} md={24} lg={24} xl={12}>
          <RunningVehicles
            title={"Least"}
            totalKm={metaData?.minRunning}
            vehicleList={metaData?.leastRunningVehicles}
          />
        </Col>
      </Row>
    </>
  );
};

export default Metrics;
